// #region imports

// --- Angular
import { Component, OnInit } from '@angular/core';

// --- HS Code
import { AppService } from '../core/services';
import { ApplicationError, ErrorMessage } from '../models';

// #endregion

@Component({
  selector: 'hs-error-test',
  templateUrl: './error-test.component.html',
  styleUrls: ['./error-test.component.scss']
})
export class ErrorTestComponent implements OnInit {

  constructor(
    private _appService: AppService
  ) {}
  ngOnInit(): void {
    const error = ApplicationError.create(
      ErrorMessage.genericErrorCode,
      'ErrorTestComponent',
      true
    );

    this._appService.setLastError(error);
  }

}
